/**
 * Fixed Symbol Table
 *
 * @module
 */

import { $$ } from '../../../utilities/QuerySelectors.js';

export class FixedSymbolTable {
    /**
     * Affix the symbol column so that horizontal scroll does not hide it.
     *
     * @param {Element} table
     */
    constructor(table) {
        this.table = table;
    }

    /**
     * Create a clone of the table with only the first column visible.
     *
     * @private
     * @return {void}
     */
    addFixedColumn() {
        /** @type {Element} */ // @ts-ignore: Casting in docblocks is ugh.
        const table = this.table.cloneNode(true);

        table.classList.add('fixed-symbol-table__fixed-column');
        table.classList.remove('fixed-symbol-table__table');

        $$('[data-quoteapi]', table).forEach((el) => el.removeAttribute('data-quoteapi'));

        this.table.parentElement.insertAdjacentElement('beforebegin', table);
        this.fixedColumn = table;
    }

    /**
     * Add CSS classes to create the fixed column illusion.
     *
     * @private
     * @return {void}
     */
    addClasses() {
        this.table.classList.add('fixed-symbol-table__table');
        this.table.parentElement.parentElement.classList.add('fixed-symbol-table-container');
    }

    /**
     * Ensure that the first column is actually the symbol.
     *
     * @private
     * @return {Boolean}
     */
    hasFirstColumnSymbol() {
        const firstValue = this.table.querySelector('td:first-child');
        return Boolean(firstValue) && firstValue.classList.contains('symbol');
    }

    /**
     * Reset the fixed column table. Useful to sync changes in the original table.
     *
     * @private
     * @return {void}
     */
    refresh() {
        this.fixedColumn.remove();
        this.addFixedColumn();
    }

    /**
     * Initialize the fixed column feature, CSS classes, and event handlers.
     *
     * @return {void}
     */
    init() {
        console.log('FixedSymbolTable.init', this.table);
        if (!this.hasFirstColumnSymbol()) {
            return;
        }
        this.addFixedColumn();
        this.addClasses();
        this.table.addEventListener('htmlchange', () => this.refresh());
    }
}
